import { ACTIONS } from "./../constants"


const initialState = {
  contractDocuments: [],
  contractDocument: {},
  totalSize: 0,
  isFetching: false, 
  isLoading: false,
  hasMore: true, 
  success: {
    isDeleted: false,
    isStatusChanged: false,
    isCreated: false,
    isUpdated: false,
  },
  error: null
}


export default (state = initialState , action) => {
  const { payload, type } = action
  switch (type) {

    case ACTIONS.CLEAR_CONTRACTS : {
      return { ...state, success: initialState.success, error: null, isFetching: false, isLoading: false }
    }

    case ACTIONS.FETCH_CONTRACTS_INIT : {
      return { ...state, isFetching: true, error: null }
    }
    case ACTIONS.FETCH_CONTRACTS_SUCCEDED : {
      const { count, results } = payload
      return { ...state, totalSize: count, contractDocuments: results, isFetching: false, error: null }
    }
    case ACTIONS.FETCH_CONTRACTS_FAILED : {
      return { ...state, isFetching: false, error: payload }
    }

    case ACTIONS.CREATE_TEMPLATE_CONTRACT_INIT : {
      return { ...state, isLoading: true, error: null, success: initialState.success }
    }
    case ACTIONS.CREATE_TEMPLATE_CONTRACT_SUCCEDED : {
      return { ...state, success: { ...state.success, isCreated: true }, isLoading: false, error: null }
    }
    case ACTIONS.CREATE_TEMPLATE_CONTRACT_FAILED : {
      return { ...state, error: payload, isLoading: false, success: false }
    }

    case ACTIONS.EDIT_TEMPLATE_CONTRACT_INIT : {
      return { ...state, isLoading: true, error: null, success: initialState.success }
    }
    case ACTIONS.EDIT_TEMPLATE_CONTRACT_SUCCEDED : {
      return { ...state, success: { ...state.success, isUpdated: true }, isLoading: false, error: null }
    }
    case ACTIONS.EDIT_TEMPLATE_CONTRACT_FAILED : {
      return { ...state, error: payload, isLoading: false, success: false }
    }
 
    case ACTIONS.FETCH_CONTRACT_INIT : {
      return { ...state, isLoading: true, contractDocument: null, error: null }
    }
    case ACTIONS.FETCH_CONTRACT_SUCCEDED : {
      return { ...state, contractDocument: payload, isLoading: false, error: null }
    }
    case ACTIONS.FETCH_CONTRACT_FAILED : {
      return { ...state, isLoading: false, error: payload }
    }

    case ACTIONS.DELETE_CONTRACT_INIT : {
      return { ...state, isLoading: true, success: initialState.success, error: null }
    }
    case ACTIONS.DELETE_CONTRACT_SUCCEDED : {
      return { ...state, success: { ...state.success, isDeleted: true }, isLoading: false, error: null }
    }
    case ACTIONS.DELETE_CONTRACT_FAILED : {
      return { ...state, isLoading: false, error: payload }
    }

    default: {
      return state
    }
  }
}
